import modalHeader from 'components/modal/modal-types/shared/modal-header'
import modalButton from 'components/modal/modal-types/shared/modal-button'
import modalTable from 'components/modal/modal-types/shared/modal-table'
import { dictionary } from 'helpers/dictionary'

import clock from 'assets/svg/icon-clock.svg'
import { parsePortName } from 'components/sailing-schedule/sailing-schedule-utils'

const modalPort = {
  async render({ id }) {
    const req = await fetch(`/webapi/sailingschedule/port?id=${id}&rand=${new Date()}`)
    const res = await req.json()
    if (!req.ok) {
      return
    }

    const data = res[0]
    if (!data) {
      return
    }

    // This title fix is temporary until they fix the service.
    const sailingSchedule = document.querySelector<HTMLElement>('.sailing-schedule')

    return `
      ${modalHeader.render({ text: parsePortName(data?.name) })}
      <div class="modal__buttons">
        ${modalButton.render({
          type: 'border',
          text: dictionary('scClosingTimes'),
          icon: clock,
          url: sailingSchedule.dataset.closingTimesPage,
        })}
        ${modalButton.render({
          type: 'default',
          text: dictionary('scRateRequest'),
          icon: '',
          url: sailingSchedule.dataset.rateRequestPage,
        })}
      </div>
      <div class="modal__table">
        ${modalTable.render({
          body: await this.handleTableBody({ data: data?.vesselSchedules }),
          thead: [
            dictionary('scVoyageNumber'),
            dictionary('scVessel'),
            dictionary('scLine'),
            dictionary('scArrival'),
            dictionary('scDeparture'),
          ],
        })}
      </div>
    `
  },

  async handleTableBody({ data }) {
    const list = []

    const datefns = await import('date-fns')

    for (let i = 0; i < data?.length; i++) {
      const rowList = []
      const obj = data[i]

      for (const key in obj) {
        switch (key) {
          case 'voyageNumber':
            rowList[0] = obj[key]
            break
          case 'name':
            rowList[1] = obj[key]
            break
          case 'lineName':
            rowList[2] = obj[key]
            break
          case 'arrivalDate':
            rowList[3] = datefns.format(new Date(obj[key]), 'dd. MMMM - HH:mm')
            break
          case 'departureDate':
            rowList[4] = datefns.format(new Date(obj[key]), 'dd. MMMM - HH:mm')
            break
        }
      }

      list.push(rowList)
    }

    return list
  },
}

export default modalPort
